export default __webpack_public_path__ + "static/media/5.7f1a132e.webp";